<template>
    <li v-click-outside="close" :class="{'is-open': opened}"><div style="display: none !important;"><svg><symbols><symbol id="sprite-triangle-down"><path d="M3.5 4L0 0h7z"/></symbol></symbols></svg></div>
        <div class="parent-link flex-container align-center align-middle" v-if="user && user.access_right_group !== 'Imagine' && user.access_right_group !== 'Tactical'">
            <button type="button" class="flex-container align-center align-middle" @click="toggle"
                    v-if="menuItem.children && menuItem.children.length > 1 || (menuItem.title === 'Formation' || menuItem.title === 'Training center')">
                {{ menuItem.title }}
                <svg inline="" width="7" height="4" class="dropdown-trigger" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4"><use xlink:href="#sprite-triangle-down"></use></svg>
            </button>
            <router-link :to="pageLink(menuItem.children[0])"
                         v-if="menuItem.children
                         && menuItem.children.length <= 1
                         && menuItem.title !== 'Formation' && menuItem.title !== 'Training center'">{{ menuItem.title }}</router-link>
        </div>
        <div class="parent-link flex-container align-left align-middle" v-if="user && user.access_right_group === 'Imagine' && user.access_right_group !== 'Tactical'">
            <button type="button" class="flex-container align-center align-middle" @click="toggle"
                    v-if="menuItem.title === 'Aménagement & mise en marché' || menuItem.title === 'Store Planning & Merchandising'">
                {{ menuItem.title }}
                <svg inline="" width="7" height="4" class="dropdown-trigger" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4"><use xlink:href="#sprite-triangle-down"></use></svg>
            </button>
            <router-link :to="pageLink(menuItem.children[0])"
                         v-if="menuItem.children
                         && menuItem.children.length <= 1
                         && menuItem.title !== 'Formation' && menuItem.title !== 'Training center'
                         && (menuItem.title === 'Aménagement & mise en marché' || menuItem.title === 'Store Planning & Merchandising')">{{ menuItem.title }}</router-link>
        </div>
        <ul class="dropdown text-center medium-text-left no-bullet" v-if="opened">
            <li v-for="(children, index) in menuItem.children" :key="`children-${index}`">
                <router-link :to="pageLink(children)" v-if="children.route_name || children.slug">{{ children.name }}</router-link>
                <span class="noselect" v-else>{{ children.name }}</span>
            </li>
            <li v-if="menuItem.title === 'Formation' || menuItem.title === 'Training center'">
                <a target="_blank" :href="'https://formation.bmr.co/'" v-translate>Training portal</a>
            </li>
        </ul>
    </li>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('bmr');

export default {
    props: ['menuItem'],
    data () {
        return {
            opened: false,
        };
    },
    computed: {
        ...mapState(['user']),
    },
    watch:{
        $route (){
            this.opened = false;
            this.$emit('close');
        }
    },
    methods: {
        pageLink (children) {
            if (children.type === 'static') {
                let routeName = this.localizedRoute(children.single_page ? 'SingleStaticDetail' : children.homepage ? 'SingleStaticList' : 'StaticList');
                let item = { name: routeName, params: { type: children.slug }};
                return item;
            }

            return { name: this.localizedRoute(children.route_name), params: children.route_params || {}};
        },
        close () {
            this.opened = false;
        },
        toggle () {
            this.opened = !this.opened;
        },
    }
};
</script>

<style lang="scss" scoped>
li {
    position: relative;
    color: $white;
}
a,
span,
button {
    @include rem-typo(14px);
    display: flex;
    text-transform: uppercase;
    font-family: $f-oswald;
    color: currentColor;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    padding: 10px 20px;
}
.parent-link {
    @include breakpoint(medium) {
        background-color: $c-atelier-dark;
        &:focus-within,
        &:hover {
            transition: all 300ms ease;
            background-color: darken($c-atelier-dark, 3%);
        }
    }
    button {
        @include breakpoint(medium) {
            min-height: 40px;
            .is-open & {
                box-shadow: inset 1px 1px 0 $c-border-color, inset -1px 1px 0 #ddd;
                background: $white;
                color: $c-atelier;
                fill: $c-atelier;
                border-radius: 0;
            }
        }
    }
}
.dropdown-trigger {
    vertical-align: middle;
    fill: currentColor;
    margin-left: 10px;
    margin-right: -10px;
    .is-open & {
        transform: rotate(180deg);
    }
}
.dropdown {
    z-index: 5;
    padding: 10px 0;
    border-top: 1px solid $c-atelier-dark;
    border-bottom: 1px solid $c-atelier-dark;
    color: $white;
    @include breakpoint(medium) {
        padding: 8px 0;
        position: absolute;
        left: 0;
        background: $white;
        border: 1px solid $c-border-color;
        border-top: 0;
    }
    a,
    span {
        display: inline-block;
        width: 100%;
        color: currentColor;
        text-transform: uppercase;
        white-space: nowrap;
        padding: 6px 30px;
        transition: all 300ms ease;
        text-decoration: none;
    }
    a {
        @include breakpoint(medium) {
            &:focus,
            &:hover {
                outline: none;
                color: $c-atelier-dark;
                transition: all 300ms ease;
            }
        }
        &.router-link-exact-active {
            font-weight: 500;
        }
        @include breakpoint(medium) {
            color: $black;
        }
    }
    span {
        color: $c-grey;
        &::after {
            content: '';
            html[lang="fr"] & {
                content: ' (Bientôt)'
            }
            html[lang="en"] & {
                content: ' (Soon)'
            }
            font-style: italic;
            @include rem-typo(10px);
        }
    }
    hr {
        margin: 10px 0 6px;
    }
}
svg {
    fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MenuItem.vue